import http from "../shared/services/http";

export const getAppKey = async () => {
  try {
    const result = await http.get(`/customer/v1/appclient`);
    return [result, null];
  } catch (err) {
    return [null, err];
  }
};

export const deleteAppKey = async (key) => {
  try {
    const result = await http.delete(`/customer/v1/appclient/${key}`);
    return [result, null];
  } catch (err) {
    return [null, err];
  }
};

export const createAppKey = async () => {
  try {
    const result = await http.post(`/customer/v1/appclient`);
    return [result, null];
  } catch (err) {
    return [null, err];
  }
};

export const getUser = async (params) => {
  try {
    const result = await http.get(`/customer/v1/user`, params);
    return [result, null];
  } catch (err) {
    return [null, err];
  }
};

export const deleteUser = async (id) => {
  try {
    const result = await http.delete(`/customer/v1/user/${id}`);
    return [result, null];
  } catch (err) {
    return [null, err];
  }
};

export const createUser = async (payload) => {
  try {
    const result = await http.post(`/customer/v1/user`, payload);
    return [result, null];
  } catch (err) {
    return [null, err];
  }
};

export const updateUser = async (user) => {
  try {
    const id = user.originalEmail;
    const payload = {
      email: user.email,
      mobileNumber: user.phone,
    };
    const result = await http.patch(`/customer/v1/user/${id}`, payload);
    return [result, null];
  } catch (err) {
    return [null, err];
  }
};

export const activateUserAuth = async (id) => {
  try {
    const result = await http.patch(`/customer/v1/user/${id}/enabled`);
    return [result, null];
  } catch (err) {
    return [null, err];
  }
};

export const updateUserSms2fa = async (userId, is2FAEnabled) => {
  try {
    const result = await http.patch(
      `/customer/v1/user/${userId}/sms2fa/${is2FAEnabled}`
    );
    return [result, null];
  } catch (err) {
    return [null, err];
  }
};

export const updateMultipleUsersSms2fa = async (payload) => {
  try {
    const result = await http.patch(`/customer/v1/user/sms2fa`, payload);
    return [result, null];
  } catch (err) {
    return [null, err];
  }
};
